<template>
  <div class="hero is-primary mb-4 mt-0 d-flex">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">{{ title }}</h1>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "Jumbotron",
  props: {
    title: String
  }
};
</script>

<style scoped>
.title {
  color: #000;
}
.hero-body {
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  padding: 3rem 1.5rem;
}
.is-primary {
  background-color: #d1ecf1;
  color: #0c5460;
}
.mb-4 {
  margin-bottom: 4px;
}
.mt-0{
  margin-top: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Jumbotron.vue